import React, { useCallback, useState } from 'react';

const VKIcon = () => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = useCallback(() => {
    setIsHovered(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setIsHovered(false);
  }, []);

  return (
    <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      {isHovered ? (
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_1848_103)">
            <path
              d="M0 12C0 6.34312 0 3.51472 1.75736 1.75736C3.51472 0 6.34312 0 12 0H13C18.6569 0 21.4853 0 23.2427 1.75736C25 3.51472 25 6.34312 25 12V13C25 18.6569 25 21.4853 23.2427 23.2427C21.4853 25 18.6569 25 13 25H12C6.34312 25 3.51472 25 1.75736 23.2427C0 21.4853 0 18.6569 0 13V12Z"
              fill="#0077FF"
            />
            <path
              d="M13.302 18.0105C7.60412 18.0105 4.35417 14.1042 4.21875 7.60425H7.07292C7.16667 12.3751 9.27078 14.3959 10.9374 14.8126V7.60425H13.6251V11.7188C15.2709 11.5417 16.9998 9.66675 17.5832 7.60425H20.2707C19.8228 10.1459 17.9478 12.0209 16.6145 12.7917C17.9478 13.4167 20.0833 15.0522 20.8958 18.0105H17.9374C17.302 16.0313 15.7188 14.5001 13.6251 14.2917V18.0105H13.302Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_1848_103">
              <rect width="25" height="25" fill="white" />
            </clipPath>
          </defs>
        </svg>) : (
        <svg width="25" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_1851_635)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M2.41459 1.75736C0.657227 3.51472 0.657227 6.34312 0.657227 12V13C0.657227 18.6569 0.657227 21.4853 2.41459 23.2427C4.17195 25 7.00035 25 12.6572 25H13.6572C19.3141 25 22.1425 25 23.8999 23.2427C25.6572 21.4853 25.6572 18.6569 25.6572 13V12C25.6572 6.34312 25.6572 3.51472 23.8999 1.75736C22.1425 0 19.3141 0 13.6572 0H12.6572C7.00035 0 4.17195 0 2.41459 1.75736ZM4.87604 7.60422C5.01146 14.1042 8.26145 18.0105 13.9594 18.0105H14.2823V14.2917C16.3761 14.5001 17.9593 16.0313 18.5947 18.0105H21.5531C20.7406 15.0521 18.6051 13.4167 17.2718 12.7917C18.6051 12.0209 20.4801 10.1459 20.928 7.60422H18.2405C17.6571 9.66672 15.9282 11.5417 14.2823 11.7188V7.60422H11.5947V14.8126C9.92806 14.3959 7.82395 12.3751 7.7302 7.60422H4.87604Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_1851_635">
              <rect width="25" height="25" fill="white" transform="translate(0.657227)" />
            </clipPath>
          </defs>
        </svg>)}
    </div>
  );
};

export default VKIcon;